import { CallCenterEndCallIcon, CallCenterListIcon2, CallerIcon, OngoingCallIcon, RecordUnfilledIcon, WaitingIcon } from "assets";
import {Typography} from "../../../../components/common";
import colors from '../../../../styles/colors.module.scss';
import './callCenterCallItemCard.scss';

type CallCenterCallItemCardProps = {
  phoneNumber: string;
  userName: string;
  agentExtension?: string;          // for active call
  agentExtensions?: string[];       // for queued call
  departmentName: string;
  duration?: string;
  serialNo?: string;
  onEndCall?: () => void;
  isQueued?: boolean;
  onClick?: () => void;
};

const departmentColors: Record<string, string> = {
  "120 Test Queue": colors.primaryText,
  "Tech_Support": colors.secondaryText,
  "Test_Queue": colors.ternaryText,
};

const CallCenterCallItemCard = ({
  phoneNumber,
  userName,
  agentExtension,
  agentExtensions = [],
  departmentName,
  duration = '',
  serialNo,
  onEndCall,
  isQueued = false,
  onClick
}: CallCenterCallItemCardProps) => {
  return (
    <li className="active-calls-list-item" onClick={onClick}>
      <div className="phone-icons-container">
        <div className="phone-recording-icon">
          {isQueued ? (
            <Typography variant="small-text-1">{serialNo}</Typography>
          ) : (
            <img src={RecordUnfilledIcon} alt="record-icon" />
          )}
        </div>
        <div className={`active-call-icon ${isQueued ? 'orange-icon' : ''}`}>
          <img src={isQueued ? WaitingIcon : OngoingCallIcon} alt="icon" />
        </div>
      </div>
      <div className="user-icon-container">
        <img src={CallCenterListIcon2} alt="icon" />
      </div>
      <div className="call-information-container">
        <div className="name-phone-container">
          <Typography variant="subHeading-1" className="user-name">{userName}</Typography>
          <Typography variant="small-text-3" className="phone-number">{phoneNumber}</Typography>
        </div>
        <div className="agency-department-container">
          {isQueued && agentExtensions?.length > 0 && (
  <div className="agency-quantity-container">
    <img src={CallerIcon} alt="caller-icon" />
    <Typography variant="small-text-3" className="agents-quantity">
      {agentExtensions.join(', ')}
    </Typography>
  </div>
)}

{!isQueued && agentExtension && (
  <div className="agency-quantity-container">
    <img src={CallerIcon} alt="caller-icon" />
    <Typography variant="small-text-3" className="agents-quantity">
      {agentExtension}
    </Typography>
  </div>
)}


          <div className="department-name-container">
            <i className="bx bx-group" />
            <Typography 
              variant="small-text-3" 
              style={{ color: departmentColors[departmentName] || 'inherit' }}
            >
              {departmentName}
            </Typography>
          </div>
        </div>
      </div>
      <div className="endButton-container">
        <div className="time-container">
          <Typography variant="small-heading-1">{duration}</Typography>
        </div>
        <button type="button" className="endIcon-container" onClick={onEndCall}>
          <img src={CallCenterEndCallIcon} alt="call-center-end-call-icon" />
        </button>
      </div>
    </li>
  );
};

export default CallCenterCallItemCard;
